import React from 'react';

import AdBox from '../adBox/adBox';

import ReduxConnect from 'Demora/redux-connect';

class StickyAdsColumn extends React.Component {
	constructor() {
		super();

		this.state = {
			position: 'static',
			orientation: 'vertical',
		};

		this.stickyContainer = React.createRef();

		this.stickyEl = React.createRef();
	}

	componentDidMount() {
		window.addEventListener('scroll', this.handleScroll);

		window.addEventListener('resize', this.handleScroll);

		this.handleScroll();
	}

	handleScroll = () => {
		let state = this.state;

		let containerel = this.stickyContainer.current;

		if (!containerel) {
			return;
		}

		let el = this.stickyEl.current;

		let sticky = containerel.getBoundingClientRect();

		let orientation = 'vertical';

		if (sticky.width > sticky.height) {
			orientation = 'horizontal';
		}

		let pos = 'static';

		if (parseFloat(el.style.top) >= sticky.top && orientation == 'vertical') {
			pos = 'fixed';
		}

		if (state.positon != pos || state.orientation != orientation) {
			this.setState({
				position: pos,
				orientation: orientation,
			});
		}
	};

	render() {
		let props = this.props;

		let state = this.state;

		if (props.user.id && !props.noAds) {
			return (
				<div className='col d-none d-lg-block flex-grow-0'>
					<div
						style={{
							height: '100vh',
							width: state.orientation == 'vertical' && '250px',
						}}
					>
						<div style={{ height: '100%' }} ref={this.stickyContainer}>
							<div
								style={{
									height: '100%',
									position: this.state.position,
									top: '72px',
									backgroundColor: '#fff',
									maxWidth: '250px',
									paddingBottom: '165px',
								}}
								ref={this.stickyEl}
							>
								<AdBox uid={props.user.id} maxAds={8} boxId='profile' />
							</div>
						</div>
					</div>
				</div>
			);
		}

		return null;
	}
}

export default ReduxConnect(StickyAdsColumn, {
	user: 'user',
});
